import { Link } from 'react-router-dom';
import { getLatestManga } from '@/mocks/manga';
import type { MangaItem } from '@/mocks/manga';

export default function LatestUpdates() {
  const latestManga = getLatestManga();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm mt-1">番木瓜漫画每日更新，精彩不容错过</p>
          </div>
          <Link
            to="/category/xuanhuan"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestManga.map((manga: MangaItem) => (
            <Link
              key={manga.slug}
              to={`/manga/${manga.slug}`}
              className="group block"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-200">
                <img
                  src={manga.cover}
                  alt={`${manga.title} - 番木瓜漫画免费阅读`}
                  title={`${manga.title} - 番木瓜漫画免费阅读下拉式`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {manga.status === '连载中' && (
                  <div className="absolute top-2 right-2 px-2 py-0.5 rounded text-[10px] font-medium bg-secondary-500 text-background-50">
                    连载
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 bg-black/60 backdrop-blur-sm px-2 py-1">
                  <span className="text-background-50 text-[10px]">
                    更新至第{manga.chapters}话
                  </span>
                </div>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}